import React from 'react'

const UpLine = () => {
    return (
        <div className=" w-full h-[12px] absolute top-0 bg-gradient-to-r from-purple-500 to-pink-500"></div>
    )
}

export default UpLine